import { createFileRoute } from '@tanstack/react-router'
import { BuyerGroupsPage } from '@/features/operations'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/buyer-groups/')({
  component: BuyerGroupsPage,
  beforeLoad: requireRole(['admin']),
})
